<tx-maintenance-bar *ngIf="maintenanceMessage$ | async" [message]="maintenanceMessage$ | async"></tx-maintenance-bar>
<div class="app-container" [ngClass]="{ 'has-maintenance-bar': (maintenanceMessage$ | async) }">
  <router-outlet></router-outlet>
  <tx-toast aria-live="polite" aria-atomic="true"></tx-toast>
</div>
<div id="circleContainer" style="position: absolute; z-index: 1055; top: 0; left: 0; display: none">
  <app-spotlight></app-spotlight>
</div>
<svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="0" width="0">
  <defs>
    <filter id="wobble">
      <feTurbulence type="fractalNoise" baseFrequency=".06" numOctaves="4" />
      <feDisplacementMap in="SourceGraphic" scale="6" />
    </filter>
  </defs>
</svg>
